export class FacePressuresPressuresAtLevel {

    constructor(calculation, data = {}) {

        this.id = data.id ?? null;
        this.uid = data.uid ?? null;
        this.calculation = calculation ?? null;
        this.facePressuresModelInterval = data.facePressuresModelInterval ?? null;
        this.tbmBoundary = data.tbmBoundary ?? null;
        this.requiredMinimumSupportForceAtTunnelAxisFaxis1 = data.requiredMinimumSupportForceAtTunnelAxisFaxis1 ?? null;
        this.requiredMinimumSupportPressureP1 = data.requiredMinimumSupportPressureP1 ?? null;
        this.totalMinimumVerticalStressAtTunnelCrownPcrown1 = data.totalMinimumVerticalStressAtTunnelCrownPcrown1 ?? null;
        this.tunnelFaceRequiredSupportWaterForceInclSafetyCoefWcis = data.tunnelFaceRequiredSupportWaterForceInclSafetyCoefWcis ?? null;
        this.tunnelFaceRequiredSupportEarthForceInclSafetyCoefEmaxcis = data.tunnelFaceRequiredSupportEarthForceInclSafetyCoefEmaxcis ?? null;
        this.requiredMinimumSupportForceAtTunnelAxisInclSafetyCoefFaxis2S = data.requiredMinimumSupportForceAtTunnelAxisInclSafetyCoefFaxis2S ?? null;
        this.requiredMinimumSupportPressureInclSafetyCoefP2S = data.requiredMinimumSupportPressureInclSafetyCoefP2S ?? null;
        this.maximumAllowableSupportPressureInclSafetyCoefPmax2S = data.maximumAllowableSupportPressureInclSafetyCoefPmax2S ?? null;
        this.requiredMinimumSupportPressureInclSafetyCoefPrDevP3Sp = data.requiredMinimumSupportPressureInclSafetyCoefPrDevP3Sp ?? null;
        this.maximumAllowableSupportPressureInclSafetyCoefPrDevPmax3Sp = data.maximumAllowableSupportPressureInclSafetyCoefPrDevPmax3Sp ?? null;
        this.waterPressurePwater = data.waterPressurePwater ?? null;
        this.finalRequiredMinimumSupportPressureInclSafetyCoefPrDevP4Spf = data.finalRequiredMinimumSupportPressureInclSafetyCoefPrDevP4Spf ?? null;

    }

    get modelInterval() {
        return this.facePressuresModelInterval?.modelInterval ?? null;
    }

    get levelAboveTbmAxis() {
        return this.tbmBoundary?.levelAboveTbmAxis ?? null;
    }

    get elevation() {
        return this.tbmBoundary?.elevation ?? null;
    }

    get objectTbm() {
        return this.tbmBoundary?.objectTbm ?? null;
    }

    get tbmAxisElevation() {
        return this.objectTbm?.axisElevation ?? null;
    }

}
